import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'

import { Container, Row, Col } from 'react-grid-system'
import moment from 'moment-timezone'

import { LoadingBoxList } from 'components/LoadingSpinner'

import EditButton from 'components/buttons/EditButton'
import DeleteButton from 'components/buttons/DeleteButton'

import styles from './index.css'

@withRouter
export default class TimesheetsList extends React.Component {
  
  static propTypes = {
    loading : PropTypes.bool,
    entities : PropTypes.arrayOf(PropTypes.object),
    onView : PropTypes.func,
    pageControl: PropTypes.any
  }

  static defaultProps = {
    loading: false,
    onView : (id) => {},
  }

  constructor(props) {
    super(props)
  }

  render() {
    return (
      <Container className={styles.List}>
        <Row className={styles.Header}>
          <Col xs={3}>
            <h1>Name</h1>
          </Col>
          <Col xs={3}>
            <h1>Date</h1>
          </Col>
          <Col xs={2}>
            <h1>Hours</h1>
          </Col>
          <Col xs={3}>
            <h1>Status</h1>
          </Col>
          <Col xs={1}>
          </Col>
        </Row>
        {
          this.props.loading && <LoadingBoxList />
        }
        {
          !this.props.loading && 
          (this.props.entities || []).map(({ id, employee_name, start_date, end_date, hours, status }) =>
            <Row className={styles.Row} key={id}>
              <Col xs={3}>
                {employee_name}
              </Col>
              <Col xs={3}>
                {moment(start_date).format('DD MMM YYYY')} - {moment(end_date).format('DD MMM YYYY')}
              </Col>
              <Col xs={2}>
                {hours}
              </Col>
              <Col xs={3}>
                {
                  status === 'pending' && <span className={styles.orange}>Pending Approval</span>
                }{
                  status === 'approved' && <span className={styles.green}>Approved</span>
                }{
                  status === 'disapproved' && <span className={styles.red}>Disapproved</span>
                }
              </Col>
              <Col xs={1} style={{display: 'flex', justifyContent: 'flex-end'}}>
                <NavLink className={styles.ViewLink} to={'/timesheets/'+id}>View</NavLink>
              </Col>
            </Row>
          )
        }
      </Container>
    )
  }

}



// WEBPACK FOOTER //
// ./src/lists/TimesheetsList/index.jsx